import { lazy, Suspense, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setChatNavigator } from "../notifications/notify";
import { useChatPopup } from "../store/popupStore";

const ChatPopup = lazy(() => import("./ChatPopup"));

/** Mounted once in Layout; loads the popup chunk only when a chat is opened. */
export function ChatPopupHost() {
  const conversationId = useChatPopup((s) => s.conversationId);
  const close = useChatPopup((s) => s.close);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Notifications («Открыть», a click on a system notification) open chats in-app.
  useEffect(() => setChatNavigator((url) => void navigate(url)), [navigate]);

  // Leaving the page (e.g. tapping the listing card inside the chat) closes it.
  const openedOn = useRef(pathname);
  useEffect(() => {
    if (conversationId) openedOn.current = pathname;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId]);
  useEffect(() => {
    if (conversationId && pathname !== openedOn.current) close();
  }, [pathname, conversationId, close]);

  // On «Сообщения» the chat opens in the page itself — a popup there sat on
  // top of the page's own thread, its composer over the other chat.
  const onMessages = pathname.startsWith("/messages");
  useEffect(() => {
    if (!conversationId || !onMessages) return;
    close();
    if (pathname !== `/messages/${conversationId}`) navigate(`/messages/${conversationId}`);
  }, [conversationId, onMessages, pathname, close, navigate]);

  if (!conversationId || onMessages) return null;
  return (
    <Suspense fallback={null}>
      <ChatPopup conversationId={conversationId} />
    </Suspense>
  );
}
